<div class="row">
  <div class="col-12 mb-3">
    <div class="automation-tabs"
      style="display: flex; gap: 4px; padding: 2px; background: #f1f5f9; border-radius: 6px; width: fit-content; border: 1px solid #e2e8f0; margin-left: 0;">
      <button class="auto-tab-btn" [class.active]="activeSubTab === 'config'" (click)="activeSubTab = 'config'"
        style="border: none; padding: 4px 10px; border-radius: 4px; font-weight: 600; font-size: 11px; cursor: pointer; transition: all 0.2s;"
        [style.background]="activeSubTab === 'config' ? '#ffffff' : 'transparent'"
        [style.color]="activeSubTab === 'config' ? '#1e293b' : '#64748b'"
        [style.boxShadow]="activeSubTab === 'config' ? '0 1px 2px rgba(0,0,0,0.05)' : 'none'">
        <i class="fa fa-cogs" style="margin-right: 4px;"
          [style.color]="activeSubTab === 'config' ? '#167FFC' : '#94a3b8'"></i> Configuration & Details
      </button>
      <button class="auto-tab-btn" [class.active]="activeSubTab === 'scripts'" (click)="activeSubTab = 'scripts'"
        style="border: none; padding: 4px 10px; border-radius: 4px; font-weight: 600; font-size: 11px; cursor: pointer; transition: all 0.2s;"
        [style.background]="activeSubTab === 'scripts' ? '#ffffff' : 'transparent'"
        [style.color]="activeSubTab === 'scripts' ? '#1e293b' : '#64748b'"
        [style.boxShadow]="activeSubTab === 'scripts' ? '0 1px 2px rgba(0,0,0,0.05)' : 'none'">
        <i class="fa fa-code" style="margin-right: 4px;"
          [style.color]="activeSubTab === 'scripts' ? '#167FFC' : '#94a3b8'"></i> Scripts Repository
      </button>
    </div>
  </div>

  @if (activeSubTab === 'config') {
  <div class="row w-100 m-0">


    <div class="col-8 col-md-8">
      <div class="card" style="height: 70px;">
        <div class="card-body" style="padding: 8px;">
          <div>
            <i class="fa fa-wrench" style="font-size: 15px"></i>
            <span style="font-size: 15px;"> {{"Configuration" | translate}} </span>
          </div>
          <div style="margin-top: 6px; display: flex; align-items: center; gap: 5px; min-width: 0;">
            <span style="font-size: 13px; flex-shrink: 0;">Appium url:</span>
            <p (click)="clickOnkeyboard(device.providerUrl)" title="Copy the URL" class="appium-url"
              style="cursor: pointer; margin: 0; font-size: 12px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; flex: 1; min-width: 0;">
              {{device.providerUrl}}
            </p>
          </div>
        </div>
      </div>
    </div>


    <div class="col-4 col-md-4">
      <div class="card" style="height: 70px;">
        <div class="card-body d-flex align-items-center justify-content-center" style="padding: 8px;">
          <button type="button" class="btn btn-primary btn-sm" (click)="routeToInspector()"
            style="width: 100%; font-size: 10px; margin-right: 5px;">
            <img src="assets/images/appium.png" style="width: 15px; height: 15px; margin-right: 5px;"
              alt="Appium logo" />
            Inbuild Inspector
          </button>
          <button type="button" class="btn btn-primary btn-sm" (click)="appiumInspector()"
            style="width: 100%; font-size: 10px;">
            <img src="assets/images/appium.png" style="width: 15px; height: 15px; margin-right: 5px;"
              alt="Appium logo" />
            Appium Inspector
          </button>
        </div>
      </div>
    </div>

    <div class="col-6 col-md-6">
      <div class="card" style="height: 350px;">
        <div class="card-body" style="padding: 15px;">
          <div class="d-flex justify-content-between align-items-center mb-3">
            <span class="capabilities-title">
              <i class="fa fa-cog me-2" style="font-size: 17px"></i>
              <span style="font-size: 17px">Capabilities</span>
            </span>
            <button type="button" class="btn btn-primary btn-sm" (click)="copyCapabilities(paragraphElement.innerText)"
              title="Copy capabilities">
              <i class="fa fa-copy"></i>
            </button>
          </div>

          <div class="capabilities-container"
            style="background-color: #f8f9fa; padding: 15px; border-radius: 5px; font-family: 'Courier New', monospace; font-size: 13px; height: 270px; overflow-y: auto; border: 1px solid #e9ecef;">
            <pre #paragraphElement class="capabilities"
              style="margin: 0; line-height: 1.6; color: #333; white-space: pre-wrap;">&#123;
            "platformName": "{{device.platform}}",
            "appium:automationName": "{{device.platform === 'Android' ? 'uiautomator2': 'XCUITest'}}",
            "appium:platformVersion": "{{device.version}}",
            "appium:deviceName": "{{device.serial}}",
            "appium:udid": "{{device.serial}}",
            "appium:apmosys.user": "{{device.owner?.email}}",
            "appium:apmosys.accessToken": "{{Token}}"
          &#125;</pre>
          </div>
        </div>
      </div>
    </div>
    <div class="col-6 col-md-6">
      <div class="card" style="height: 350px;">
        <div class="card-body d-flex flex-column" style="padding: 15px;">
          <div class="d-flex justify-content-between align-items-center mb-3">
            <span>
              <i class="fa fa-suitcase" style="font-size: 17px; margin-right: 8px;"></i>
              <span style="font-size: 17px">{{"Package Information" | translate}}</span>
            </span>
            <button type="button" class="btn btn-primary btn-sm" (click)="getPackageName()">
              <i class="fa fa-search"></i> {{"Get Package" | translate}}
            </button>
          </div>

          <div class="package-details flex-grow-1 d-flex flex-column justify-content-center" style="height: 270px;">
            <div class="w-100">
              @if (device.ios) {
              <div>
                <div class="package-item mb-3">
                  <div class="package-label mb-1" style="font-size: 14px; color: #666;">
                    <i class="fab fa-apple"></i>
                    Bundle ID:
                  </div>
                  <div class="package-value-container d-flex align-items-center">
                    <span class="package-value flex-grow-1 p-2 bg-light rounded"
                      style="word-break: break-all; font-size: 12px; min-height: 40px; display: flex; align-items: center;">
                      {{packageName || 'com.example.dummy'}}
                    </span>
                    <button type="button" class="btn btn-primary btn-sm ms-2" (click)="copyBundleId()"
                      title="Copy Bundle ID">
                      <i class="fa fa-copy"></i>
                    </button>
                  </div>
                </div>
              </div>
              } @else {
              <div class="package-item mb-3">
                <div class="package-label mb-1" style="font-size: 14px; color: #666;">
                  <i class="fab fa-android"></i>
                  Package Name:
                </div>
                <div class="package-value-container d-flex align-items-center">
                  <span class="package-value flex-grow-1 p-2 bg-light rounded"
                    style="word-break: break-all; font-size: 12px; min-height: 40px; display: flex; align-items: center;">
                    {{packageName || 'com.example.dummy'}}
                  </span>
                  <button type="button" class="btn btn-primary btn-sm ms-2" (click)="copyPackageName()"
                    title="Copy Package Name">
                    <i class="fa fa-copy"></i>
                  </button>
                </div>
              </div>
              <div class="package-item mb-3">
                <div class="package-label mb-1" style="font-size: 14px; color: #666;">
                  <i class="fa fa-play-circle"></i>
                  Activity Name:
                </div>
                <div class="package-value-container d-flex align-items-center">
                  <span class="package-value flex-grow-1 p-2 bg-light rounded"
                    style="scrollbar-width: thin;overflow: auto;word-break: break-all; font-size: 12px; min-height: 40px; display: flex; align-items: center;">
                    {{activityName || 'com.example.dummy.MainActivity'}}
                  </span>
                  <button type="button" class="btn btn-primary btn-sm ms-2" (click)="copyActivityName()"
                    title="Copy Activity Name">
                    <i class="fa fa-copy"></i>
                  </button>
                </div>
              </div>
              }


              <!-- Info message -->
              <div class="text-center mt-3" style="font-size: 12px; color: #888;">
                <i class="fa fa-info-circle me-1"></i>
                Click "Get Package" to retrieve package information
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-12 col-md-12">
      <div class="card">
        <div class="card-body">
          <div class="d-flex justify-content-between align-items-center">
            <div>
              <i class="fa fa-save" style="margin-right: 7px; font-size: 17px;"></i>
              <span style="font-size: 17px;">{{"Download Automation Set-up Document" | translate}}</span>
            </div>
            <!-- routeToInspector(); -->
            <button class="btn btn-primary" type="button" (click)="downloadFile();">
              <i class="fa fa-download" aria-hidden="true" style="margin-right: 7px;"></i>
              <span>{{"Automation set-up Document" | translate}}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  }

  @if (activeSubTab === 'scripts') {
  <app-script-repository [device]="device" [currentUser]="currentUser" [Token]="Token">
  </app-script-repository>
  }

  <ng-template #alerttemplate let-modal>
    <div class="modal-body text-center">
      <p class="alert-message" style="overflow-wrap: break-word;">{{msg | translate}}</p>
      <div class="alert-actions">
        <button type="button" class="btn btn-success" (click)="Ok()">{{"OK" | translate}}</button>&nbsp;
      </div>
    </div>
  </ng-template>

  @if (showAppiumAlert) {
  <div class="alert-overlay">
    <div class="alert-box">
      <div class="alert-icon">
        <div class="spinner-border text-warning" role="status"></div>
      </div>
      <div class="alert-content">
        <h5>Appium Inspector</h5>
        <p>Creating Appium Session...</p>
      </div>
    </div>
  </div>
  }